import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
const links = [{
  label: 'Why AVEGA',
  href: '#why'
}, {
  label: 'The app',
  href: '#app'
}, {
  label: 'Ways to play',
  href: '#play'
}, {
  label: 'Privacy',
  href: '#privacy'
}, {
  label: 'FAQ',
  href: '#faq'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > window.innerHeight * 0.7);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const solid = scrolled || open;
  return <header className="fixed inset-x-0 top-4 z-50 px-4" data-id="element-150" data-mp="1q0nptk1fznlk">
      <nav aria-label="Main" className={`mx-auto flex h-14 max-w-5xl items-center justify-between rounded-full pl-5 pr-2 transition-[background-color,box-shadow] duration-200 ease-out ${solid ? 'bg-canvas/85 shadow-[0_10px_30px_-12px_rgba(11,42,32,0.25)] ring-1 ring-ink/5 backdrop-blur-xl' : 'bg-white/[0.06] ring-1 ring-white/10 backdrop-blur-md'}`} data-id="element-151" data-mp="1kyewunokkljg">
        <a href="#top" className="rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mint" data-id="element-152" data-mp="ol8d1cbg5x85">
          <Logo tone={solid ? 'dark' : 'light'} data-id="element-153" data-mp="3n19krqgk7lt1" />
        </a>
        <ul className="hidden items-center gap-7 lg:flex" data-id="element-154" data-mp="3s3ib0f21s9rg">
          {links.map(l => <li key={l.href} data-id="element-155" data-mp="v4j5wo29buc">
              <a href={l.href} className={`whitespace-nowrap text-sm font-medium transition-colors duration-150 ${solid ? 'text-muted hover:text-ink' : 'text-white/70 hover:text-white'}`} data-id="element-156" data-mp="uutybaub8pp">
                {l.label}
              </a>
            </li>)}
        </ul>
        <div className="flex items-center gap-1" data-id="element-157" data-mp="31ahxp3cvmyan">
          <a href="#download" className={`whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold transition-[background-color,transform] duration-150 active:scale-[0.97] ${solid ? 'bg-forest text-white hover:bg-forest-deep' : 'bg-mint text-forest-deep hover:bg-white'}`} data-id="element-158" data-mp="3196ub4ncfsk2">
            Get the app
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className={`grid h-10 w-10 place-items-center rounded-full lg:hidden ${solid ? 'text-ink' : 'text-white'}`} data-id="element-159" data-mp="2icxh0jk9n614">
            {open ? <XIcon className="h-5 w-5" data-id="element-160" data-mp="7jkyzdaeme7e" /> : <MenuIcon className="h-5 w-5" data-id="element-161" data-mp="7it301cwaegl" />}
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-162" data-mp="2khqfiv7tpuo">
        {open && <motion.div id="mobile-menu" initial={{
        opacity: 0,
        y: -8,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -8,
        scale: 0.98
      }} transition={{
        duration: 0.2,
        ease
      }} className="mx-auto mt-2 max-w-5xl rounded-3xl bg-canvas p-3 shadow-xl ring-1 ring-ink/5 lg:hidden" data-id="element-163" data-mp="a4sd7n87mn4m">
            {links.map(l => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block rounded-2xl px-4 py-3 font-display text-lg font-semibold text-ink hover:bg-white" data-id="element-164" data-mp="surz618r7m3t">
                {l.label}
              </a>)}
          </motion.div>}
      </AnimatePresence>
    </header>;
}